// xstate Events
export const NEXT = 'NEXT';
export const PREV = 'PREV';
export const RESET = 'RESET';
export const SUBMIT = 'SUBMIT';
export const JUMP_TO_CONTACTFORM = 'JUMP_TO_CONTACTFORM';
